export default __webpack_public_path__ + "static/media/instagram.3a458a32.png";